import React, { createContext, useContext, useReducer } from 'react';
import { IThemeContext } from './theme.interfaces';
import { themeInitialState, themeReducer } from './themeReducer';
export const ThemeContext = createContext<IThemeContext | undefined>(undefined);

export interface IThemeProviderProps {
  children: React.ReactNode;
}

export const ThemeProvider = ({ children }: IThemeProviderProps) => {
  const [state, dispatch] = useReducer(themeReducer, themeInitialState);
  const value = { state, dispatch, loading: false };

  return (
    <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>
  );
};

export const useThemeContext = () => {
  const context = useContext(ThemeContext);

  if (context === undefined) {
    throw new Error('useThemeContext must be used within a ThemeProvider');
  }
  return { ...context };
};
